function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Location from '../geom/Location';
import hasInterface from '../../../../hasInterface';
import Coordinate from '../geom/Coordinate';
import CoordinateSequence from '../geom/CoordinateSequence';
import RobustLineIntersector from './RobustLineIntersector';
import RayCrossingCounter from './RayCrossingCounter';
var PointLocation = /*#__PURE__*/function () {
  function PointLocation() {
    _classCallCheck(this, PointLocation);
    PointLocation.constructor_.apply(this, arguments);
  }
  return _createClass(PointLocation, [{
    key: "getClass",
    value: function getClass() {
      return PointLocation;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "isOnLine",
    value: function isOnLine() {
      if (arguments[0] instanceof Coordinate && hasInterface(arguments[1], CoordinateSequence)) {
        var p = arguments[0];
        var line = arguments[1];
        var lineIntersector = new RobustLineIntersector();
        var p0 = new Coordinate();
        var p1 = new Coordinate();
        var n = line.size();
        for (var i = 1; i < n; i++) {
          line.getCoordinate(i - 1, p0);
          line.getCoordinate(i, p1);
          lineIntersector.computeIntersection(p, p0, p1);
          if (lineIntersector.hasIntersection()) {
            return true;
          }
        }
        return false;
      } else if (arguments[0] instanceof Coordinate && arguments[1] instanceof Array) {
        var _p = arguments[0];
        var _line = arguments[1];
        var _lineIntersector = new RobustLineIntersector();
        for (var _i = 1; _i < _line.length; _i++) {
          var _p2 = _line[_i - 1];
          var _p3 = _line[_i];
          _lineIntersector.computeIntersection(_p, _p2, _p3);
          if (_lineIntersector.hasIntersection()) {
            return true;
          }
        }
        return false;
      }
    }
  }, {
    key: "locateInRing",
    value: function locateInRing(p, ring) {
      return RayCrossingCounter.locatePointInRing(p, ring);
    }
  }, {
    key: "isInRing",
    value: function isInRing(p, ring) {
      return PointLocation.locateInRing(p, ring) !== Location.EXTERIOR;
    }
  }]);
}();
export { PointLocation as default };
PointLocation.constructor_ = function () {};